var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 5.50012H2.8125C2.55362 5.50012 2.34375 5.72398 2.34375 6.00012V13.0001C2.34375 13.2763 2.55362 13.5001 2.8125 13.5001H12.1875C12.4464 13.5001 12.6562 13.2763 12.6562 13.0001V6.00012C12.6562 5.72398 12.4464 5.50012 12.1875 5.50012Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39062 5.50012V3.25012C5.39063 2.65338 5.61286 2.08109 6.00845 1.65913C6.40403 1.23717 6.94056 1.00012 7.5 1.00012C8.05944 1.00012 8.59597 1.23717 8.99155 1.65913C9.38714 2.08109 9.60938 2.65338 9.60938 3.25012V5.50012",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.2501C7.88833 10.2501 8.20312 9.91434 8.20312 9.50012C8.20312 9.08591 7.88833 8.75012 7.5 8.75012C7.11167 8.75012 6.79688 9.08591 6.79688 9.50012C6.79688 9.91434 7.11167 10.2501 7.5 10.2501Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.c7d61904a20a0bcf2b072a5be3a708a0.svg";
export { ForwardRef as ReactComponent };